import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PrimeNGConfig } from 'primeng/api';
import { environment } from '../environments/environment';
import { AuthLifecycleStorageService } from './core/services/auth-lifecycle-storage.service';
import { ConsentService } from './core/services/consent/consent.service';
import { EventTrackerService } from './core/services/event-tracker/event-tracker.service';
import { LanguageService } from './core/services/language.service';
import { RouteCheckerService } from './core/services/route-checker.service';
import { UserConfigurationService } from './core/services/user-configuration.service';
import { MigrationDataDialogService } from './shared/components/migration-data-dialog/migration-data-dialog.service';
import { Languages } from './shared/enums/languages.enum';
import { ThemeService } from './whitelabel/services/theme.service';

@Component({
  selector: 'osp-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, AfterViewInit {
  public title = 'frontend-revolution';
  public isPublicRoute = this.routeCheckerService.isPublicRoute();
  public isTheftProtectionAlarmRoute = this.routeCheckerService.isTheftProtectionAlarmRoute();

  constructor(
    private readonly primengConfig: PrimeNGConfig,
    private readonly languageService: LanguageService,
    private readonly titleService: Title,
    private readonly routeCheckerService: RouteCheckerService,
    private readonly themeService: ThemeService, // injection is needed so that all subpages have access to theme
    private readonly migrationDataDialogService: MigrationDataDialogService,
    private readonly authLifecycleStorageService: AuthLifecycleStorageService,
    private readonly eventTrackerService: EventTrackerService,
    private readonly userConfigurationService: UserConfigurationService,
    private readonly consentService: ConsentService,
  ) {
    this.setTitleAndFavicon();
    this.languageService.setDefaultLanguage(environment.FALLBACK_LANGUAGE ?? Languages.EN);
    if (this.authLifecycleStorageService.isJustAuthenticated) {
      this.trackEventLogin();
    }
  }

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.migrationDataDialogService.startMigrationOnInit();
  }

  ngAfterViewInit(): void {
    this.consentService.init();
  }

  private setTitleAndFavicon() {
    this.titleService.setTitle(environment.PAGE_TITLE);
    this.setFavicon(environment.PAGE_FAVICON);
  }

  setFavicon(url: string) {
    const link: HTMLLinkElement = document.querySelector("link[rel~='icon']") || document.createElement('link');
    link.rel = 'icon';
    link.href = url;
    document.head.appendChild(link);
  }

  private trackEventLogin(): void {
    const customerName = this.userConfigurationService.getCustomerName();
    this.eventTrackerService.trackLogin(customerName);
  }
}
